import { api } from './api';
import {
  RevOpsBrief,
  BriefFeedback,
  BriefComment,
  SubmitLikePayload,
  SubmitCommentPayload,
  NotesResponse,
} from '../Models/RevOpsBrief';

export const revOpsBriefApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLatestBrief: build.query<RevOpsBrief | null, void>({
      query: () => ({ url: 'revops-brief/latest', method: 'GET' }),
      providesTags: ['RevOpsBrief'],
    }),
    getFeedback: build.query<BriefFeedback, string>({
      query: (date) => ({ url: `revops-brief/feedback?date=${date}`, method: 'GET' }),
      providesTags: ['RevOpsBriefFeedback'],
    }),
    submitLike: build.mutation<void, SubmitLikePayload>({
      query: (body) => ({ url: 'revops-brief/feedback/like', method: 'POST', body }),
      async onQueryStarted({ item_id, liked, brief_date, section }, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          revOpsBriefApi.util.updateQueryData('getFeedback', brief_date, (draft) => {
            const existing = draft.likes.find((l) => l.item_id === item_id);
            if (existing) {
              existing.liked = liked;
            } else {
              draft.likes.push({ item_id, liked, section });
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
    }),
    submitComment: build.mutation<BriefComment, SubmitCommentPayload>({
      query: (body) => ({ url: 'revops-brief/feedback/comment', method: 'POST', body }),
      invalidatesTags: ['RevOpsBriefFeedback'],
    }),
    deleteLike: build.mutation<void, { item_id: string; brief_date: string }>({
      query: ({ item_id }) => ({ url: `revops-brief/feedback/like/${item_id}`, method: 'DELETE' }),
      async onQueryStarted({ item_id, brief_date }, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          revOpsBriefApi.util.updateQueryData('getFeedback', brief_date, (draft: BriefFeedback) => {          
            draft.likes = draft.likes.filter((l) => l.item_id !== item_id);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
    }),
    getNotes: build.query<NotesResponse, { start_date: string; end_date: string }>({
      query: ({ start_date, end_date }) => ({
        url: `revops-brief/feedback/notes?start_date=${start_date}&end_date=${end_date}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetLatestBriefQuery,
  useGetFeedbackQuery,
  useSubmitLikeMutation,
  useSubmitCommentMutation,
  useDeleteLikeMutation,  
  useGetNotesQuery,
} = revOpsBriefApi;